import React from "react";
import { useDocumentMeta } from "../components/useDocumentMeta";
import HubSpotForm from "../components/HubSpotForm";
import { contactEmail, hubspotForm, hubspotMeetingUrl } from "../config/booking";

function Contact() {
  useDocumentMeta(
    "Talk to us",
    "Talk to the BoldBrave and Logikfabriken team about your Internal Developer Platform.",
  );

  return (
    <section className="section contact-section">
      <div className="container contact-layout">
        <div className="contact-intro">
          <p className="kicker">Talk to us</p>
          <h1 className="page-title">Let's talk platforms</h1>
          <p className="page-lead">
            Have questions about building or scaling your Internal Developer
            Platform on Red Hat Developer Hub and Backstage? Book a time that
            works for you, or send us a message.
          </p>

          <figure className="quote-card">
            <blockquote>
              "Backstage is allowing us to actually surface information that
              hasn't been possible in the past, which is super exciting — all
              within the context of their applications and their components."
            </blockquote>
            <figcaption>Director of Experience Design</figcaption>
          </figure>

          <div className="contact-direct">
            <a href="mailto:magnus@bold-n-brave.com">
              Magnus Christiansson · BoldBrave
            </a>
            <a href="mailto:jesper@logikfabriken.se">
              Jesper Lindberg · Logikfabriken
            </a>
          </div>
        </div>

        <div className="contact-form-panel">
          <div className="contact-block">
            <h2 className="contact-block-title">Book a meeting</h2>
            <p className="contact-block-lead">
              Tell us a little about where you are, and we'll take you straight
              to our calendar to pick a time.
            </p>
            <HubSpotForm
              portalId={hubspotForm.portalId}
              formId={hubspotForm.formId}
              region={hubspotForm.region}
              redirectUrl={hubspotMeetingUrl}
              fallbackUrl={`mailto:${contactEmail}`}
              fallbackLabel="Email us"
            />
          </div>

          <div className="contact-block">
            <h2 className="contact-block-title">Or send us a message</h2>
            <p className="contact-block-lead">
              Prefer to write? Drop us a line and we'll get back to you.
            </p>
            <div className="registration-fallback">
              <a className="cta-button" href={`mailto:${contactEmail}`}>
                Email us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
